import styled, { css } from "styled-components";

const colorStyles = {
  normal: {
    bg: "#5A8DEE",
    itemsColor: "#fff",
    border: "none",
  },
  secondary: {
    bg: "#475F7B",
    itemsColor: "#fff",
    border: "none",
  },
  success: {
    bg: "#ADC86A",
    itemsColor: "#fff",
    border: "none",
  },
  error: {
    bg: "#FF3333",
    itemsColor: "#fff",
    border: "none",
  },
  alert: {
    bg: "#F6B000",
    itemsColor: "#fff",
    border: "none",
  },
  info: {
    bg: "#BEDEEC",
    itemsColor: "#596778",
    border: "none",
  },
  alternative: {
    bg: "#fff",
    itemsColor: "#5A8DEE",
    border: "1px solid #5A8DEE",
  },
  notify: {
    bg: "#5A8DEE",
    itemsColor: "#fff",
    border: "1px solid #5A8DEE",
  },
};

// "warning" é usado em várias telas, mas não existia: o toast quebrava a página
// inteira ("Cannot read properties of undefined (reading 'bg')"). Vira o "alert",
// e um tipo desconhecido cai no "normal" em vez de derrubar a tela
colorStyles.warning = colorStyles.alert;
const cores = type => colorStyles[type] ?? colorStyles.normal;

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 30%;
  min-width: 300px;
  max-width: 90vw;
  position: fixed;
  margin-right: 10px;
  ${props =>
    props.align === `normal` &&
    css`
      bottom: 0;
      right: 0;
      margin-bottom: 5%;
    `};
  ${props =>
    props.align === `top` &&
    css`
      margin-top: 8%;
      top: 0;
      right: 0;
    `};

  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.3);
  padding: 16px;
  border-radius: 5px;
  background-color: ${props => cores(props.type).bg};
  border: ${props => cores(props.type).border};

  p {
    font-size: 15px;
    color: ${props => cores(props.type).itemsColor};
  }

  svg {
    margin-right: 8px;
    fill: ${props => cores(props.type).itemsColor};
  }

  .close {
    margin: 0;
    margin-left: auto;
  }
`;

export const ContainerDescription = styled.div`
  width: 100%;
  min-width: 0;
  h3 {
    font-size: 15px;
    color: ${props => cores(props.type).itemsColor};
  }
  p {
    font-size: 13px;
    color: ${props => cores(props.type).itemsColor};
    white-space: normal;
    word-break: break-word;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }
  p.detail {
    margin-top: 4px;
    font-size: 12px;
    opacity: 0.9;
  }
`;

export const DetailToggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  font-size: 12px;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;

  svg {
    margin-right: 0;
  }
`;
